/** @format */

import React from 'react'
import './App.css'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Home from './pages/home.jsx'
import About from './pages/about.jsx'
import Shopstatic from './pages/shop_static.jsx'
import Privaypolicy from './pages/privacy_policy.jsx'
import TermsandConditions from './pages/terms_conditions.jsx'
import Refundpolicy from './pages/refund_policy.jsx'
import Team from './pages/team.jsx'



export class App extends React.Component {
	render() {
		return (
			<Router>
				
				<Switch>
					<Route exact path='/' component={Home} />
					<Route exact path='/about' component={About} />
					<Route exact path='/terms_conditions' component={TermsandConditions} />
					<Route exact path='/privacy_policy' component={Privaypolicy} />
					<Route exact path='/refund_policy' component={Refundpolicy} />
					<Route exact path='/shop_static' component={Shopstatic} />
					<Route exact path='/team' component={Team} />

				</Switch>


			</Router>
		)
	}
}
